var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#000",
    strokeWidth: 0.7,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.286 12.497h0V6.43a2.143 2.143 0 1 1 4.285 0v6.156h0v5.844",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.857 12.543h0v5.886a2.143 2.143 0 0 1-4.286 0V12.58h0V6.43",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.857 18.429v-5.79h0v-6.21a2.143 2.143 0 1 1 4.286 0v6.212h0",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.429 12.542v5.887a2.143 2.143 0 1 1-4.286 0v-12M4.286 12.497H0",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M21.429 12.542H24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFuel);
export default __webpack_public_path__ + "static/media/ic-fuel.2d2199acc03a3b2e8e67f2f7b05338f8.svg";
export { ForwardRef as ReactComponent };